import React, { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { parseQuery } from "../../utils/query";
import RouteDetailContainer from "./components/RouteDetailContainer";
import { stringifyQuery } from "../../utils/query";
import {
  controlLockedByNotification,
  hideAllNotifications,
  unlockRoute,
  resetAllTransferFromRouteEntity,
  setSaveRouteEnable,
  setRouteDetail,
} from "../../store/actions/route";
import { getRouteLockedBy } from "../../store/selectors/route";
import { onCloseScheduleRoute } from "../../store/actions/schedule";

export default ({ routeDetail }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const routeLockedBy = useSelector(getRouteLockedBy);

  useEffect(() => {
    dispatch(controlLockedByNotification(routeLockedBy));
  }, [routeLockedBy, dispatch]);

  useEffect(
    () => async () => {
      try {
        await dispatch(unlockRoute());
      } catch {
      } finally {
        dispatch(setRouteDetail(null));
        dispatch(resetAllTransferFromRouteEntity());
        dispatch(hideAllNotifications());
        dispatch(setSaveRouteEnable(false));
        dispatch(onCloseScheduleRoute());
      }
    },
    [dispatch]
  );

  const handleBackClick = useCallback(async () => {
    const { detailVisible, ...newQuery } = parseQuery(history.location.search);
    history.push({
      search: stringifyQuery(newQuery),
    });
  }, [history]);

  return (
    <RouteDetailContainer
      route={routeDetail}
      handleBackClick={handleBackClick}
    />
  );
};
